import React, { Dispatch, SetStateAction } from 'react';

import { Checkbox, Link, Typography } from '@vtblife/uikit';

const QuizBuilderFinalStepAgreement = ({ value, handleChange }: {
    value: boolean;
    handleChange: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <Checkbox
            value={value}
            onChange={handleChange}
        >
            <Typography variant='secondary-alone'>
                Я&nbsp;ознакомлен с&nbsp;{
                    <Link
                        href='https://m2.ru/support/clients/soglasheniya/privacy-policy/'
                        target='blank'
                    >
                        <Typography variant='secondary-alone'>
                            Политикой&nbsp;конфиденциальности
                        </Typography>
                    </Link>
                } и&nbsp;согласен на&nbsp;получение консультаций, информационных и/или&nbsp;рекламных рассылок
            </Typography>
        </Checkbox>
    );
};

export default QuizBuilderFinalStepAgreement;
